import { Link } from 'react-router-dom';
import { ArrowRight, ListOrdered, Workflow, BookOpen } from 'lucide-react';
import { useScenarios } from '@/hooks/useScenarios';

export default function ScenariosListPage() {
    const { scenarios, loading, error } = useScenarios();

    return (
        <div className="max-w-4xl mx-auto px-6 lg:px-8 py-10">
            {/* Breadcrumb-style eyebrow */}
            <div className="flex items-center gap-1.5 text-xs mb-4" style={{ color: 'var(--ghost)' }}>
                <BookOpen className="h-3 w-3" />
                <span>Docs</span>
                <span>/</span>
                <span style={{ color: 'var(--muted)' }}>Scenarios</span>
            </div>

            <h1 className="text-3xl font-semibold tracking-tight mb-3" style={{ color: 'var(--ink)' }}>
                Multi-step runner
            </h1>
            <p className="text-base leading-relaxed mb-8 max-w-2xl" style={{ color: 'var(--muted)' }}>
                Jalankan rangkaian endpoint berurutan — variabel hasil step pertama otomatis dipakai
                di step berikutnya. Cocok buat smoke-test integrasi atau seed data demo.
            </p>

            {loading && (
                <div className="text-sm" style={{ color: 'var(--muted)' }}>
                    Memuat daftar scenario…
                </div>
            )}

            {error && !loading && (
                <div
                    className="px-4 py-3 rounded-lg text-sm"
                    style={{
                        backgroundColor: 'var(--err-bg)',
                        color: 'var(--err)',
                        border: '1px solid var(--err-border)',
                    }}
                >
                    {error}
                </div>
            )}

            {!loading && !error && scenarios.length === 0 && (
                <div className="text-sm" style={{ color: 'var(--muted)' }}>Belum ada scenario tersedia.</div>
            )}

            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                {scenarios.map((s) => (
                    <article
                        key={s.id}
                        className="p-5 rounded-lg flex flex-col gb-card-hover"
                        style={{
                            backgroundColor: 'var(--bg)',
                            border: '1px solid var(--border)',
                        }}
                    >
                        <div className="flex items-start gap-3 mb-3">
                            <div
                                className="h-9 w-9 rounded-md flex items-center justify-center shrink-0"
                                style={{
                                    backgroundColor: 'var(--accent-bg)',
                                    color: 'var(--accent)',
                                }}
                            >
                                <Workflow className="h-4 w-4" />
                            </div>
                            <div className="flex-1 min-w-0">
                                <h2 className="text-sm font-semibold leading-tight" style={{ color: 'var(--ink)' }}>
                                    {s.title}
                                </h2>
                                <p className="text-xs mt-1 inline-flex items-center gap-1" style={{ color: 'var(--ghost)' }}>
                                    <ListOrdered className="h-3 w-3" />
                                    {s.stepCount} langkah
                                </p>
                            </div>
                        </div>
                        <p className="text-sm leading-relaxed mb-4 flex-1" style={{ color: 'var(--muted)' }}>
                            {s.description}
                        </p>
                        <Link
                            to={`/scenarios/${s.id}`}
                            className="self-start inline-flex items-center gap-1.5 text-sm font-medium transition-opacity hover:opacity-80"
                            style={{ color: 'var(--accent)' }}
                        >
                            Buka scenario <ArrowRight className="h-3.5 w-3.5" />
                        </Link>
                    </article>
                ))}
            </div>
        </div>
    );
}
